import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";

export default function ResetPassword({ token }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("6 caractères minimum"); return; }
    if (password !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset", { token, password });
      setDone(true);
      toast.success("Mot de passe mis à jour !");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || "Échec");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 dot-grid">
      <div className="w-full max-w-md glass rounded-2xl border border-border p-7 fade-up">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-md overflow-hidden border border-primary/40 glow-primary shrink-0">
            <img src="/ksos-logo.jpg" alt="KSOS HUB" className="w-full h-full object-cover" />
          </div>
          <div>
            <div className="font-head font-bold text-xl tracking-wide text-glow">KSOS HUB</div>
            <div className="text-[10px] text-muted-foreground tracking-[0.2em] uppercase">Réinitialisation</div>
          </div>
        </div>

        {done ? (
          <div className="text-center py-6" data-testid="reset-success">
            <CheckCircle2 className="w-12 h-12 mx-auto mb-3" style={{ color: "#22C55E" }} />
            <p className="text-sm text-slate-300 mb-5">Ton mot de passe a été mis à jour. Tu peux te connecter.</p>
            <a href="/" data-testid="reset-back-login" className="inline-flex items-center justify-center rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/85 transition-colors">
              Aller à la connexion
            </a>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <p className="text-sm text-muted-foreground mb-2">Choisis ton nouveau mot de passe.</p>
            <div className="relative">
              <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <input data-testid="reset-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Nouveau mot de passe" className="cfg-input pl-9" />
            </div>
            <div className="relative">
              <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
              <input data-testid="reset-password-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirme le mot de passe" className="cfg-input pl-9" />
            </div>
            <button data-testid="reset-submit" type="submit" disabled={busy}
              className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-primary py-2.5 text-sm font-semibold text-primary-foreground hover:bg-primary/85 transition-colors disabled:opacity-50">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
              Réinitialiser mon mot de passe
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
